import React, { useState, useEffect, Component, useRef } from "react";
import Cookies from "js-cookie";
import { useForm } from "react-hook-form";
import DatePicker from "react-datepicker";
import axios from "axios";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import TableView from "../TableView";
import "react-datepicker/dist/react-datepicker.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Voyage = () => {
  const storedToken = Cookies.get("authToken");
  const storedUser = Cookies.get("authUser");
  const [authtoken, setAuthToken] = useState(storedToken || "");
  const [authUser, setAuthUser] = useState(storedUser || "");
  // const [baseUrl, setBaseUrl] = useState('http://127.0.0.1:8000/api/');
  const [baseUrl, setBaseUrl] = useState("https://devmol.evolve-demo.com/api/");
  const [pageComponent, setPageComponent] = useState("voyages");
  const [data, setData] = useState(undefined);
  const [vesselId, setVesselId] = useState("");
  const [vesselCode, setVesselCode] = useState("");
  const [vesselList, setVesselList] = useState(undefined);
  const [vesselDescVal, setVesselDescVal] = useState("");
  const [voyageCode, setVoyageCode] = useState("");
  const [voyageDesc, setVoyageDesc] = useState("");
  const [arrivalDate, setArrivalDate] = useState("");
  const [depatureDate, setDepatureDate] = useState("");
  const [oldVoylCode, setOldVoylCode] = useState("");
  const [btnActive, setBtnActive] = useState(true);
  const [selectRowData, setSelectRowData] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState("");
  const [emptyVesCode, setEmptyVesCode] = useState(false);
  const [emptyVoyage, setEmptyVoyage] = useState(false);
  const [emptyVoyageDesc, setEmptyVoyageDesc] = useState(false);
  const [emptyArrDate, setEmptyArrDate] = useState(false);
  const [emptyDepatureDate, setEmptyDepatureDate] = useState(false);
  const [emptyInput, setEmptyInput] = useState(false);

  const inputRef = useRef();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  function dateSetting(date) {
    let selected_Date = date;

    date !== null
      ? setStartDate(selected_Date) ||
        setArrivalDate(date.toLocaleDateString("sv-SE")) ||
        setEmptyArrDate(false)
      : toast.error("Arrival Date can not be empty", {
          position: toast.POSITION.TOP_RIGHT,
        });
  }

  function endDateSet(date) {
    date !== null
      ? setEndDate(date) ||
        setDepatureDate(date.toLocaleDateString("sv-SE")) ||
        setEmptyDepatureDate(false)
      : toast.error("Depature Date can not be empty", {
          position: toast.POSITION.TOP_RIGHT,
        });
  }

  const createNewRow = () => {
    console.log("createNewRow function is calling");
    setBtnActive(false);
    setSelectRowData("");
    setVoyageCode("");
    setVoyageDesc("");
  };

  useEffect(() => {
    fetch(`${baseUrl}vessels/dropdown`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        // setVesselList(data.vessels);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const setVessel = (e) => {
    setVesselId(e);
    console.log(e);
    const selectedVessel = vesselList.find((row) => row.id == e);
    console.log(selectedVessel);
    setVesselCode(selectedVessel.vessel_code);
    setVesselDescVal(selectedVessel.vessel_description);
  };

  function setSelectedRow(rowid) {
    const currunt_ID = rowid;
    console.log(currunt_ID);
    axios
      .get(`${baseUrl}${pageComponent}/single/${rowid}`, {
        headers: {
          Authorization: `Bearer ${authtoken}`,
        },
      })
      .then((res) => {
        const selectRowData = res.data.voyage[0];
        setSelectRowData(selectRowData);
        console.log(selectRowData);

        setVesselId(selectRowData.vessel_id1 ? selectRowData.vessel_id1 : "");
        setVesselCode(
          selectRowData.vessel_code ? selectRowData.vessel_code : ""
        );
        setVesselDescVal(
          selectRowData.vessel_description
            ? selectRowData.vessel_description
            : ""
        );
        setVoyageCode(
          selectRowData.voyage_code ? selectRowData.voyage_code : ""
        );
        setOldVoylCode(
          selectRowData.voyage_code ? selectRowData.voyage_code : ""
        );
        setVoyageDesc(
          selectRowData.voyage_description
            ? selectRowData.voyage_description
            : ""
        );
        let aRRDate = selectRowData.voyage_arrival_date
          ? selectRowData.voyage_arrival_date
          : "";
        setStartDate(new Date(aRRDate));
        setArrivalDate(
          selectRowData.voyage_arrival_date
            ? selectRowData.voyage_arrival_date
            : ""
        );
        let dPTDate = selectRowData.voyage_departure_date
          ? selectRowData.voyage_departure_date
          : "";
        setEndDate(new Date(dPTDate));
        setDepatureDate(
          selectRowData.voyage_departure_date
            ? selectRowData.voyage_departure_date
            : ""
        );
        setBtnActive(false);
      });
  }

  const handleSave = (event) => {
    event.preventDefault();
    setEmptyInput(false);

    if (vesselCode.length == 0) {
      toast.error("Vessel Code can not be empty", {
        position: toast.POSITION.TOP_RIGHT,
      });
      setEmptyVesCode(true);
      setEmptyInput(true);
      return;
    } else {
      setEmptyVesCode(false);
    }

    if (voyageCode.length == 0) {
      toast.error("Voyage Code can not be empty", {
        position: toast.POSITION.TOP_RIGHT,
      });
      setEmptyVoyage(true);
      setEmptyInput(true);
    } else {
      setEmptyVoyage(false);
    }

    if (voyageDesc.length == 0) {
      toast.error("Voyage Description can not be empty", {
        position: toast.POSITION.TOP_RIGHT,
      });
      setEmptyVoyageDesc(true);
      setEmptyInput(true);
    } else {
      setEmptyVoyageDesc(false);
    }

    if (startDate == null) {
      toast.error("Arrival Date can not be empty", {
        position: toast.POSITION.TOP_RIGHT,
      });
      setEmptyArrDate(true);
      setEmptyInput(true);
    } else {
      setEmptyArrDate(false);
      setEmptyInput(false);
    }

    if (endDate.length == 0) {
      toast.error("Depature Date can not be empty", {
        position: toast.POSITION.TOP_RIGHT,
      });
      setEmptyDepatureDate(true);
      setEmptyInput(true);
    } else {
      setEmptyDepatureDate(false);
      setEmptyInput(false);
    }

    if (emptyInput !== true) {
      const inputData = {
        vessel_id: vesselId,
        voyage_code: voyageCode,
        voyage_description: voyageDesc,
        voyage_arrival_date: arrivalDate,
        voyage_departure_date: depatureDate,
      };
      const duplicate = data.some((el) => el.VoyCode === voyageCode);

      duplicate == true
        ? toast.error("This Voyage code already included", {
            position: toast.POSITION.TOP_RIGHT,
          })
        : axios
            .post(`${baseUrl}${pageComponent}/store`, inputData, {
              method: "GET",
              headers: {
                Authorization: `Bearer ${authtoken}`,
              },
            })
            .then((response) => {
              console.log(response.data);
              toast.success("Successfully Save Data ! ", {
                position: toast.POSITION.TOP_RIGHT,
              });
              setTimeout(window.location.reload.bind(window.location), 2000);
            })
            .catch((error) => {
              toast.error("error", {
                position: toast.POSITION.TOP_RIGHT,
              });
            });
    }
  };

  useEffect(() => {
    fetch(`${baseUrl}${pageComponent}/all`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setData(data.voyages);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const edditRow = (event) => {
    event.preventDefault();

    if (selectRowData !== "") {
      setEmptyInput(false);

      if (vesselCode.length == 0) {
        toast.error("Vessel Code can not be empty", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setEmptyVesCode(true);
        setEmptyInput(true);
        return;
      } else {
        setEmptyVesCode(false);
      }

      if (voyageCode.length == 0) {
        toast.error("Voyage Code can not be empty", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setEmptyVoyage(true);
        setEmptyInput(true);
      } else {
        setEmptyVoyage(false);
      }

      if (voyageDesc.length == 0) {
        toast.error("Voyage Description can not be empty", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setEmptyVoyageDesc(true);
        setEmptyInput(true);
      } else {
        setEmptyVoyageDesc(false);
      }

      if (startDate == null) {
        toast.error("Arrival Date can not be empty", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setEmptyArrDate(true);
        setEmptyInput(true);
      } else {
        setEmptyArrDate(false);
        setEmptyInput(false);
      }

      if (endDate.length == 0) {
        toast.error("Depature Date can not be empty", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setEmptyDepatureDate(true);
        setEmptyInput(true);
      } else {
        setEmptyDepatureDate(false);
        setEmptyInput(false);
      }

      if (emptyInput !== true) {
        const inputData = {
          vessel_id: vesselId,
          voyage_code: voyageCode,
          voyage_description: voyageDesc,
          voyage_arrival_date: arrivalDate,
          voyage_departure_date: depatureDate,
        };
        console.log(inputData);
        axios
          .post(
            `${baseUrl}${pageComponent}/update/${selectRowData.id}`,
            inputData,
            {
              method: "POST",
              headers: {
                Authorization: `Bearer ${authtoken}`,
              },
            }
          )
          .then((response) => {
            console.log(response.data);
            window.location.reload(false);
            toast.success("Successfully Save Data ! ", {
              position: toast.POSITION.TOP_RIGHT,
            });
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        toast.error("Please Select data Row", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  };

  const deleteRow = (event) => {
    event.preventDefault();
    axios
      .delete(`${baseUrl}${pageComponent}/destroy/${selectRowData.id}`, {
        headers: {
          Authorization: `Bearer ${authtoken}`,
        },
      })
      .then(() => {
        toast.warning("Successfully Deleted Data Row", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setTimeout(() => window.location.reload(), 2000);
      })
      .catch((error) => {
        toast.error("Error deleting row:", error, {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const tTitle = [
    "Vessel Code",
    "Vessel Description",
    "Voyage Code",
    "Voyage Description",
    "Voy Arriva Date",
    "Voy DeapDate",
  ];

  const columns = [
    "vessel_code",
    "vessel_description",
    "voyage_code",
    "voyage_description",
    "voyage_arrival_date",
    "voyage_departure_date",
  ];
  return (
    <Container fluid>
      <ToastContainer autoClose={2000} />
      <Row>
        <Col>
          <Form className="mt-3 bottom-border pb-3">
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="Vessel">
                  <Form.Label>Vessel </Form.Label>
                  <Form.Select
                    aria-label=""
                    className={emptyVesCode == true ? "border-red2" : ""}
                    value={vesselCode}
                    onChange={(e) => setVessel(e.target.value)}
                  >
                    <>
                      {vesselCode !== "" ? (
                        <>
                          <option value={vesselCode}>{vesselDescVal}</option>
                          {vesselList !== undefined
                            ? vesselList.map((vesselItem) =>
                                vesselCode != vesselItem.id ? (
                                  <option
                                    value={vesselItem.id}
                                    key={vesselItem.id}
                                  >
                                    {vesselItem.vessel_description}
                                  </option>
                                ) : (
                                  ""
                                )
                              )
                            : ""}
                        </>
                      ) : vesselList !== undefined ? (
                        vesselList.map((vesselItem) =>
                          vesselCode !== vesselItem.id ? (
                            <option value={vesselItem.id} key={vesselItem.id}>
                              {vesselItem.vessel_description}
                            </option>
                          ) : (
                            ""
                          )
                        )
                      ) : (
                        ""
                      )}
                    </>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="Voyage_code">
                  <Form.Label>Voyage Code</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="VesCode"
                    readOnly={selectRowData !== "" ? true : false}
                    name="VesselCode"
                    className={emptyVoyage == true ? "border-red2" : ""}
                    value={voyageCode}
                    onChange={(e) => setVoyageCode(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="Voyage_des">
                  <Form.Label>Voyage Desc</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="VesDesc"
                    name="VesselDesc"
                    className={emptyVoyageDesc == true ? "border-red2" : ""}
                    value={voyageDesc}
                    onChange={(e) => setVoyageDesc(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              {/* <Col>
                                <Form.Group className="mb-3" controlId="Arrival_date">
                                    <Form.Label>Arrival Date</Form.Label>
                                    <Form.Control type="date" placeholder="14/Dec/2022" name="ArrivalDate" value={arrivalDate} onChange={e => setArrivalDate(e.target.value)} />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="Depature_Date" name="depatureDate" >
                                    <Form.Label>Depature Date</Form.Label>
                                    <Form.Control type="date" placeholder="15/Dec/2022" name="depatureDate" value={depatureDate} onChange={e => setDepatureDate(e.target.value)} />
                                </Form.Group>
                            </Col> */}
              <Col>
                <Form.Group className="mb-3" controlId="Arrival_date">
                  <Form.Label>Arrival Date </Form.Label>
                  <DatePicker
                    selectsStart
                    selected={startDate}
                    onChange={(Date) => dateSetting(Date)}
                    startDate={startDate}
                    className={emptyArrDate == true ? "border-red2" : ""}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group
                  className="mb-3"
                  controlId="Depature_Date"
                  name="depatureDate"
                >
                  <Form.Label>Depature Date</Form.Label>
                  <DatePicker
                    selectsEnd
                    selected={endDate}
                    onChange={(date) => endDateSet(date)}
                    endDate={endDate}
                    startDate={startDate}
                    minDate={startDate}
                    className={emptyDepatureDate == true ? "border-red2" : ""}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="text-center">
              <Col className="text-end">
                <Button
                  className="ms-3"
                  variant="primary"
                  onClick={selectRowData !== "" ? edditRow : handleSave}
                  disabled={btnActive}
                >
                  Save
                </Button>

                <Button
                  className="ms-3"
                  variant="primary"
                  onClick={createNewRow}
                >
                  New
                </Button>

                <Button
                  className="ms-3"
                  variant="primary"
                  onClick={edditRow}
                  disabled={btnActive}
                >
                  Update
                </Button>
                <Button
                  className="ms-3"
                  variant="primary"
                  onClick={deleteRow}
                  disabled={btnActive}
                >
                  Delete
                </Button>

                <Button className="ms-3" variant="primary" disabled={btnActive}>
                  Print
                </Button>

                <Button className="ms-3" variant="primary" type="submit">
                  Cancel
                </Button>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col>
          <TableView
            data={data}
            columns={columns}
            tTitle={tTitle}
            setSelectedRow={setSelectedRow}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default Voyage;
